import { UserSkill } from './skills';

export class UserSkillsWrapper {
    public userId: number = 0;
    public userName: string = '';
    public skills: UserSkill[] = [];
}